import { defaultHttpClient } from '../../httpClient';
import type { GetMarketParentGoodsCarouselResponse } from './types';

export const getMarketParentGoodsCarousel = (marketId: number) => {
  return defaultHttpClient
    .request<GetMarketParentGoodsCarouselResponse>({
      url: `/api/v2/markets/${marketId}/parent/goods-carousels/`,
      method: 'GET',
    })
    .then(result => result.data);
};
